<div class="bfx-connection-monitor__container">
  <!-- BODY -->
  <div class="bfx-connection-monitor__body">
    <p-tabView
      [activeIndex]="selectedTab"
      #tv
      (onChange)="onTabSelected($event)"
      styleClass="bfx-tabview"
    >
      <p-tabPanel header="Connections" #tabConnections>
        <bfx-connection-monitor-connections #connections></bfx-connection-monitor-connections>
      </p-tabPanel>
      <p-tabPanel header="Audit" #tabAudit>
        <bfx-connection-monitor-audit #audit></bfx-connection-monitor-audit>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
